// extracted by mini-css-extract-plugin
export default {"horizontal":"tmHsxH","vertical":"Dgf2Op","bullet":"Ki_0_s"};